module.exports = __webpack_public_path__ + "assets/images/businessCard-03.d9903893fc342351ec0b5f050074f868.svg";